import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import './form.css';

const PricingPublicCalculator = () => {
  const { t } = useTranslation();

  const BASE_FEE = 59.0;
  const ADDITIONAL_FEE = 25.0;
  const PLATFORM_FEE = 50.0;
  const ADDON_FEE = 15.0;

  const [maxPractitioners, setMaxPractitioners] = useState(1);
  const [valueAdded, setValueAdded] = useState(false);

  const calculateSubtotal = () => {
    return maxPractitioners > 1
      ? BASE_FEE + (maxPractitioners - 1) * ADDITIONAL_FEE
      : BASE_FEE;
  };

  const subtotal = calculateSubtotal();
  const totalBeforeHST = subtotal + (valueAdded ? ADDON_FEE : 0);

  return (
    <>
     
      <div className="pricing-details-form-public">
         <h2 className="pricing-public-main-title">{t("pricing.title")}</h2>
        <div className="grid-layout-pricing">
          <div className="left-column-pricing">
            <div className="input-and-addon-box">
              <div className="boxed-section">
                <h4 className="form-header-no-align">{t("register_pricing.right_column_title")}</h4>
                <p className="section-note">{t("register_pricing.practitioner_limit_note")}</p>
                <div className="form-row">
                  <label className="form-label">
                    {t("register_pricing.max_practitioners")}<span className="required">*</span>
                  </label>
                  <div className="counter_price_detail">
                    <button
                      type="button"
                      className="counter-btn_price_detail"
                      onClick={() => setMaxPractitioners(Math.max(1, maxPractitioners - 1))}
                    >
                      -
                    </button>
                    <span className="counter-value_price_detail">{maxPractitioners}</span>
                    <button
                      type="button"
                      className="counter-btn_price_detail"
                      onClick={() => setMaxPractitioners(maxPractitioners + 1)}
                    >
                      +
                    </button>
                  </div>
                </div>

                <hr style={{ margin: '1rem 0' }} />

                <h4 className="value-added-title">{t("register_pricing.value_added_services_heading")}</h4>
                <div className="form-row checkbox-row-pricing">
                  <label className="checkbox-label-pricing">
                    <input
                      type="checkbox"
                      checked={valueAdded}
                      onChange={(e) => setValueAdded(e.target.checked)}
                    />
                    {t("register_pricing.sms_addon_label")}
                  </label>
                </div>
              </div>

              <div className="cost-breakdown_price_detail boxed-section">
                <h4 className="form-header-no-align">{t("register_pricing.calculator_header")}</h4>
                <p className="calculator-note_price_detail">{t("register_pricing.calculator_note")}</p>

                <p>{t("register_pricing.base_fee")}: ${BASE_FEE.toFixed(2)}</p>
                {maxPractitioners > 1 && (
                  <p>
                    {t("register_pricing.additional_fee", {
                      count: maxPractitioners - 1,
                      fee: ADDITIONAL_FEE.toFixed(2),
                    })}
                  </p>
                )}
                <p>{t("register_pricing.subtotal")}: ${subtotal.toFixed(2)}</p>
                {valueAdded && (
                  <p>{t("register_pricing.addon_fee_label")}: ${ADDON_FEE.toFixed(2)}</p>
                )}
                <p className="total_price_detail">
                  {t("register_pricing.total_before_tax")}: 
                  <strong>
                    ${totalBeforeHST.toFixed(2)}
                    <span className="required-two">*</span>
                  </strong>
                </p>
                <p className="tax-note">* {t("register_pricing.tax_note")}</p>
              </div>
            </div>

            <div className="platform-fee-box">
              <h4 className="form-header">{t("register_pricing.platform_fee_header")}</h4>
              <p style={{color: 'var(--clr-grey-1)'}}>{t("register_pricing.platform_fee")}: ${PLATFORM_FEE.toFixed(2)}</p>
              <p className="platform-total">
                {t("register_pricing.platform_total")}: 
                <strong>
                  ${PLATFORM_FEE.toFixed(2)}
                  <span className="required-two">*</span>
                </strong>
              </p>
              <p style={{color: 'var(--clr-grey-1)'}} className="tax-note">* {t("register_pricing.tax_note")}</p>
            </div>
          </div>

          <div className="right-column-pricing">
            <div className="features-box" style={{ backgroundColor: 'var(--clr-white)' }}>
              <h2>{t("register_pricing.features_included_title")}</h2>

              <div className="feature-group">
                <h5>{t("register_pricing.group_scheduling")}</h5>
                <ul className="feature-list">
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_1")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_2")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_3")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_4")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_5")}</li>
                </ul>
              </div>

              <div className="feature-group">
                <h5>{t("register_pricing.group_operations")}</h5>
                <ul className="feature-list">
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_6")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_7")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_8")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_9")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_10")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_14")}</li>
                </ul>
              </div>

              <div className="feature-group">
                <h5>{t("register_pricing.group_security")}</h5>
                <ul className="feature-list">
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_11")}</li>
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_12")}</li>
                </ul>
              </div>

              <div className="feature-group">
                <h5>{t("register_pricing.group_special")}</h5>
                <ul className="feature-list">
                  <li><span className="feature-icon">✅</span>{t("register_pricing.feature_13")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingPublicCalculator;
